import type { ReactElement, ReactNode } from 'react';

import { cn } from '../lib/cn.js';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../primitives/Card.js';

export interface PageSectionCardProps {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  contentClassName?: string;
  children: ReactNode;
}

export function PageSectionCard({
  title,
  description,
  action,
  contentClassName,
  children,
}: PageSectionCardProps): ReactElement {
  return (
    <Card className="border-border bg-card shadow-md shadow-foreground/5 transition-shadow duration-200 hover:shadow-xl hover:shadow-foreground/10 dark:shadow-xl dark:shadow-black/30 dark:hover:shadow-2xl dark:hover:shadow-black/50">
      <CardHeader className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-2">
          <CardTitle>{title}</CardTitle>
          {description ? (
            <CardDescription className="text-base leading-7 text-muted-foreground">
              {description}
            </CardDescription>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </CardHeader>
      <CardContent className={cn('pt-0', contentClassName)}>{children}</CardContent>
    </Card>
  );
}
